import React from 'react';
import { Divider } from 'components/elements/divider/Divider';
import { FeaturedArticles } from 'components/featured-articles/FeaturedArticles';
import { FeaturedArticlesItem } from 'components/featured-articles/FeaturedArticlesItem';

export const Component = () => {
  const image = { url: 'https://picsum.photos/id/983/400/400', width: 400, height: 400 };

  return (
    <>
      <Divider>Default Featured Articles with Images</Divider>
      <FeaturedArticles
        index={1}
        tagline="Newsroom"
        title="Latest initiatives, programs and news"
        // design="default"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris congue aliquam lectus
            vitae rhoncus. In malesuada mauris viverra tristique posuere.
          </p>
        }
        link={{ href: '' }}
        isSlice
      >
        <FeaturedArticlesItem
          tagline="Iceland"
          title="Fund-raising concert for Nepal"
          date="16 February 2022"
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <FeaturedArticlesItem
          tagline="Romania"
          title="Charity football game in Romania"
          date="16 February 2022"
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <FeaturedArticlesItem
          tagline="Iceland"
          title="Alvogen Midnight Time Trial"
          date="16 February 2022"
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
      </FeaturedArticles>
      <Divider>Simplified Featured Articles without Images</Divider>
      <FeaturedArticles
        index={2}
        design="simple"
        tagline="Newsroom"
        title="Latest news"
        text={
          <p>
            Follow the various Alvogen projects and tasks in a stream of news articles as they
            unfold.
          </p>
        }
        link={{ href: '' }}
        buttonText="Newsroom"
        isSlice
      >
        <FeaturedArticlesItem
          tagline="Business"
          title="Alvotech Upsizes Oversubscribed PIPE Transaction to Approximately $175 Million"
          date="18 january 2022"
          link={{ href: 'https://kodo.is' }}
        />
        <FeaturedArticlesItem
          tagline="Business"
          title="JAMP and Alvotech Announce Canadian Approval of SIMLANDI™, a High-Concentration Biosimilar to Humira®, Providing Access to Previously Unavailable Versions in Canada"
          date="10 january 2022"
          link={{ href: 'https://kodo.is' }}
        />
        <FeaturedArticlesItem
          tagline="Business"
          title="AVT02 Approved for Use in European Union"
          date="10 january 2022"
          link={{ href: 'https://kodo.is' }}
        />
      </FeaturedArticles>
    </>
  );
};
